
import UserAccountMenu from '@/components/UserAccountMenu'
import EmailVerificationBanner from '@/components/EmailVerificationBanner'
import { COOKIE_DURATION, cookieOpts } from '@/utils/cookieOptions'

export default {
  name: 'AccountLayout',
  components: { UserAccountMenu, EmailVerificationBanner },
  data() {
    return {
      messageDismissed: false,
    }
  },
  computed: {
    messageCompteClient() {
      return this.$store.state.message_compte_client
    },
    showMessageCompteClient() {
      return (
        this.messageCompteClient &&
        this.messageCompteClient.text &&
        !this.messageDismissed &&
        !this.$nuxtCookies.get('dismiss_message_compte_client')
      )
    },
  },
  mounted() {
    this.$store.dispatch('setMessageCompteClient')

    if (this.$route.query.token) {
      this.$userService
        .verifyEmail({ token: this.$route.query.token })
        .then(() => {
          this.$swalCustomSuccess(
            this.$t('layouts.account.emailVerifiedTitle'),
            this.$t('layouts.account.emailVerifiedMessage')
          )
          this.$auth.fetchUser()
          this.$router.push(
            this.localePath({
              name: 'compte',
              query: {
                token: undefined,
              },
            })
          )
        })
        .catch(error => {
          const tokenError = error.response?.data?.errors?.token?.[0]

          if (tokenError) {
            this.$swalInfoCustomMessage(
              this.$t('layouts.account.emailVerificationFailedTitle'),
              tokenError.startsWith('validation.')
                ? this.$t('layouts.account.emailVerificationFailedMessage')
                : tokenError
            )
          } else {
            this.$swalErrorMessage(error)
          }

          this.$router.push(
            this.localePath({
              name: 'compte',
              query: {
                token: undefined,
              },
            })
          )
        })
    }
  },
  methods: {
    dismissMessage() {
      this.messageDismissed = true
      this.$nuxtCookies.set('dismiss_message_compte_client', true, cookieOpts(COOKIE_DURATION.MONTH))
    },
  },
}
